import useCountdown from "hooks/useCountdown";
import React, { useEffect } from "react";
import { twMerge } from "tailwind-merge";

function replaceHalfOfString(str) {
  var halfLength = Math.floor(str.length / 2);
  var firstHalf = str.substring(0, halfLength);
  var secondHalf = "?".repeat(str.length - halfLength);
  return firstHalf + secondHalf;
}

export default function ItemHint({
  seconds,
  hint,
  isGameOver = false,
  enabled = true,
}) {
  const codeLength = String(hint).length;
  
  const countdown = useCountdown({
    autoStart: enabled && !isGameOver,
    seconds,
  });

  const countdownSeconds = countdown.seconds;
  const level2 = Math.floor(seconds * 0.3);
  const level3 = Math.floor(seconds * 0.8);
  
  const hintString = isGameOver
    ? hint
    : countdownSeconds >= level3
    ? String(hint).replace(/\d/g, "?")
    : countdownSeconds >= level2
    ? replaceHalfOfString(hint)
    : hint;

  const hintWidthClass = {
    2: "w-10",
    3: "w-14",
    4: "w-20",
  }[codeLength];

  useEffect(() => {
    if (isGameOver || !enabled) {
      countdown.pause();
    } else {
      countdown.start();
    }
  }, [enabled, isGameOver]);

  return (
    <div
      className={twMerge(
        "absolute opacity-80 tracking-widest left-2 top-2  p-1 h-10 rounded-sm backdrop-blur-xl bg-black/30 text-indigo-50 font-bold text-lg",
        hintWidthClass
      )}
    >
      {hintString}
    </div>
  );
}
